import React from 'react'
import { Card, CardContent, Typography, Chip, Box } from '@mui/material'
import { CheckCircle, Cancel } from '@mui/icons-material'

const CardStatus = ({ dados }) => {
  const status = dados?.tpStatus

  const ativo =
    status === true || status === 'ATIVO' || status === 'A' || status === 1

  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        borderRadius: 3,
      }}
    >
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          Status
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'start',
            mt: 1,
          }}
        >
          <Chip
            icon={ativo ? <CheckCircle /> : <Cancel />}
            label={ativo ? 'Ativa' : 'Inativa'}
            color={ativo ? 'success' : 'error'}
            size="medium"
            sx={{
              '& .MuiChip-label': {
                color: '#fff',
                fontWeight: 600,
              },
              '& .MuiChip-icon': {
                color: '#fff',
              },
            }}
          />
        </Box>
      </CardContent>
    </Card>
  )
}

export default CardStatus
